import { API_URL } from 'core/infra/environment'
import { HttpClient } from 'core/infra/http/HttpClient'

import sentry from 'legacy/utils/sentry'

import { SpotQuoteRepository } from '../infra/SpotQuoteRepository'

export type RejectSpotQuoteFactoryDependencies = {
  spotQuoteRepository: SpotQuoteRepository
}

export function rejectSpotQuoteFactory({
  spotQuoteRepository,
}: RejectSpotQuoteFactoryDependencies) {
  return async function submit(id: string, reason: string, config?: { signal?: AbortSignal }) {
    try {
      return await spotQuoteRepository.rejectSpotQuote(id, reason, config)
    } catch (error) {
      sentry.log(error)
      throw new Error('Could not reject the spot quote', { cause: error as Error })
    }
  }
}

export function rejectSpotQuote(id: string, reason: string, config?: { signal?: AbortSignal }) {
  const httpClient = new HttpClient(API_URL)
  const spotQuoteRepository = new SpotQuoteRepository({ httpClient })
  const submit = rejectSpotQuoteFactory({ spotQuoteRepository })

  return submit(id, reason, config)
}
